'use strict';

var _ = require('lodash');
var ScenarioService = function ScenarioService($filter, $q, Restangular, Scenario, $rootScope, configurationService, momentService, scenarioConstants) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var service = Restangular.service('scenario');
  var serviceFlight = Restangular.service('domain/flights/scenarioReoptimization');
  var serviceAdjustments = Restangular.service('adjustments/productionize');
  var CARRIER = configurationService.getHostCarrier();
  var scenarioLoaded = false;
  var scenarios = [];
  var selectedScenario = null;
  function transformScenarios(collection) {
    scenarios = _.transform(collection, function (scenarios, item) {
      var scenario;
      scenario = new Scenario();
      scenario.fromResponse(item);
      scenario.reoptStatus = scenarioConstants.REOPTIMIZATION_STATUSES_MAP[scenario.reoptStatus] || scenarioConstants.REOPTIMIZATION_STATUSES.notOptimized;
      scenario.ruleRefs = _.chain(scenario.ruleRefs).uniqBy('optGroupDate').map(function (ruleRef) {
        var momentDate = momentService.of(ruleRef.optGroupDate, momentService.FIELD.OPT_GROUP_DATE);
        return {
          label: rmMomentFormat(momentDate, 'DATE_USER_SETTINGS'),
          momentDate: momentDate
        };
      }).value();
      return scenarios.push(scenario);
    });
    return scenarios;
  }
  function getScenarioList() {
    if (!scenarioLoaded) {
      updateScenarioList();
      scenarioLoaded = true;
    }
    return scenarios;
  }
  function updateScenarioList() {
    $rootScope.$broadcast('scenarios:load');
    var parameters = {
      filter: 'createdBy==\'' + configurationService.getUserId() + '\''
    };
    return service.one().get(parameters).then(function (data) {
      scenarioLoaded = true;
      var allScenarios = transformScenarios(data.scenarios);
      scenarios = _.reject(allScenarios, isPreviewRequest);
      $rootScope.$broadcast('scenarios:loaded');
      return data;
    });
  }
  function createPreviewRequest(scenarioName) {
    var createdBy = configurationService.getUserId();
    var scenario = new Scenario(scenarioName, createdBy, scenarioConstants.REOPTIMIZATION_STATUSES.waitingToOptimize);
    return createScenario(scenario);
  }
  function clearStalePreviewRequest(scenarioName) {
    if (isPreviewRequest(scenarioName)) {
      var createdBy = configurationService.getUserId();
      var scenarioToBeDeleted = createdBy + '_' + scenarioName;
      return service.one(scenarioToBeDeleted).remove({
        noSpinner: true
      }, {
        userName: createdBy
      });
    } else {
      return $q.when({});
    }
  }
  function createScenario(scenario) {
    return service.post(scenario);
  }
  function selectScenario(scenario, skipSearch) {
    selectedScenario = scenario;
    $rootScope.$broadcast('scenarios:changed', selectedScenario, skipSearch);
  }
  function clearScenarioSelection(scenario) {
    if (selectedScenario && scenario && selectedScenario.id === scenario.id) {
      selectScenario(null);
    }
  }
  function deleteScenario(scenario) {
    clearScenarioSelection(scenario);
    var createdBy = configurationService.getUserId();
    return service.one(scenario.scenarioName).remove({}, {
      userName: createdBy
    }).then(updateScenarioList);
  }
  function optimizeScenario(scenario) {
    return serviceFlight.post({
      'scenarioName': scenario.scenarioName,
      'carrier': CARRIER
    }).then(updateScenarioList);
  }
  function saveToProduction(scenario) {
    return serviceAdjustments.one(scenario.scenarioName).put().then(updateScenarioList).then(function () {
      selectScenario(null);
    });
  }
  function isScenarioSelected() {
    return !!selectedScenario;
  }
  function getSelectedScenario() {
    return selectedScenario;
  }
  function getSelectedScenarioName() {
    return selectedScenario ? selectedScenario.scenarioName : null;
  }
  function getReoptStatuses() {
    return scenarioConstants.REOPTIMIZATION_STATUSES;
  }
  function isPreviewRequest(scenario) {
    if (!_.isNil(scenario) && scenario.displayName) {
      return scenario.displayName === scenarioConstants.ND_PREVIEW_REQUEST || scenario.displayName === scenarioConstants.MD_PREVIEW_REQUEST;
    } else {
      return _.endsWith(scenario, scenarioConstants.ND_PREVIEW_REQUEST) || _.endsWith(scenario, scenarioConstants.MD_PREVIEW_REQUEST);
    }
  }
  function getCurrentUserNDPreviewRequestName() {
    var userId = configurationService.getUserId();
    return userId + '_' + scenarioConstants.ND_PREVIEW_REQUEST;
  }
  function getCurrentUserMDPreviewRequestName() {
    var userId = configurationService.getUserId();
    return userId + '_' + scenarioConstants.MD_PREVIEW_REQUEST;
  }
  function checkSelectedScenarioReoptStatus(status) {
    return isScenarioSelected() && selectedScenario.reoptStatus === status;
  }
  return {
    createScenario: createScenario,
    createPreviewRequest: createPreviewRequest,
    clearStalePreviewRequest: clearStalePreviewRequest,
    getScenarioList: getScenarioList,
    deleteScenario: deleteScenario,
    optimizeScenario: optimizeScenario,
    selectScenario: selectScenario,
    getSelectedScenario: getSelectedScenario,
    getSelectedScenarioName: getSelectedScenarioName,
    isScenarioSelected: isScenarioSelected,
    updateScenarioList: updateScenarioList,
    getReoptStatuses: getReoptStatuses,
    saveToProduction: saveToProduction,
    isPreviewRequest: isPreviewRequest,
    getCurrentUserNDPreviewRequestName: getCurrentUserNDPreviewRequestName,
    getCurrentUserMDPreviewRequestName: getCurrentUserMDPreviewRequestName,
    PUBLISHED: scenarioConstants.PUBLISHED,
    NDPreviewRequest: scenarioConstants.ND_PREVIEW_REQUEST,
    MDPreviewRequest: scenarioConstants.MD_PREVIEW_REQUEST,
    checkSelectedScenarioReoptStatus: checkSelectedScenarioReoptStatus
  };
};
ScenarioService.$inject = ['$filter', '$q', 'Restangular', 'ScenarioFactory', '$rootScope', 'ConfigurationService', 'MomentService', 'ScenarioConstants'];
module.exports = ScenarioService;